import { render, staticRenderFns } from "./DokmanComponentLenkungDurchdringung.vue?vue&type=template&id=a54a15b2&scoped=true"
import script from "./DokmanComponentLenkungDurchdringung.vue?vue&type=script&lang=js"
export * from "./DokmanComponentLenkungDurchdringung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54a15b2",
  null
  
)

export default component.exports